import { Component } from '@angular/core';
import { AppToolbar } from '../../components/app-toolbar/app-toolbar';
import { InteractiveLogo } from '../../components/interactive-logo/interactive-logo';

@Component({
  selector: 'app-start-page',
  imports: [AppToolbar, InteractiveLogo],
  templateUrl: './start-page.html',
  styleUrl: './start-page.scss',
})
export class StartPage {}
